/**
 * Lightweight fallback shown while a lazily-loaded route chunk is fetched.
 * Intentionally dependency-free and tiny so it is always available immediately.
 */
export default function PageLoader() {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label="Loading"
      className="flex min-h-[60vh] w-full items-center justify-center"
    >
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-muted border-t-primary" />
      <span className="sr-only">Loading…</span>
    </div>
  );
}
